import { type SVGProps } from "react";

const AtariController = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Joystick base */}
    <rect x="6" y="14" width="12" height="7" rx="2" />
    {/* Stick */}
    <line x1="12" y1="14" x2="12" y2="5" />
    {/* Stick knob */}
    <circle cx="12" cy="4" r="2" />
    {/* Button */}
    <circle cx="18" cy="17.5" r="1" fill="currentColor" />
  </svg>
);

export default AtariController;
